import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge Tailwind classes with deterministic precedence. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
